import React, { useContext, useState } from 'react'
import { AuthContext } from '../../context/AuthContext'
import AxioInstance from '../../axios/AxiosConfig'

export const ModalPassword = ({ handleOK = () => { }, handleCancel = () => { } }) => {
    const { getAuthenticatedHeaders, userDetailsContext } = useContext(AuthContext)
    const [error, setError] = useState(null)
    const [password, setPassword] = useState('')
    const [loading, setLoading] = useState(false)
    const checkUserPassword = async (password) => {
        setLoading(true)
        if (!password) {
            setLoading(false)

            return;
        }
        const data = {
            username: userDetailsContext?.username,
            password: password,
        };
        AxioInstance.post(
            `/api/login`,
            { data },
            {
                headers: await getAuthenticatedHeaders(),
            }
        ).then((response) => {
            if (response.data?.status === 200 /* true */) {
                handleOK()

            } else {
                if (response.data?.data?.detail === 'Usuario o contraseña inválidos') {
                    setError("Contraseña incorrecta");
                } else {
                    setError('Estamos presentado inconveniente')
                }
            }
            setLoading(false)

        }).catch((error) => {
            setLoading(false)

        });
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && !loading) {
            checkUserPassword(password);
        }
    };

    return (
        <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative w-auto my-2 mx-auto max-w-xs">
                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="relative p-6 flex-auto">

                            <p className="my-4 text-gray-600 text-lg leading-relaxed">Ingresa tu contraseña</p>
                            <input
                                aria-label="Password"
                                name="password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                onKeyDown={handleKeyDown}
                                type="password"
                                required
                                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                                placeholder="Contraseña"
                            ></input>
                            {error &&
                                <div className="relative flex justify-center py-3 px-4 mx-auto w-auto"><p className="text-red-500 text-xs italic">{error} </p></div>
                            }
                        </div>

                        <div className="flex items-center justify-end p-6 border-t border-solid border-gray-300 rounded-b">
                            <button
                                className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 rounded-full"
                                type="button"
                                style={{ transition: "all .15s ease" }}
                                onClick={() => handleCancel()}
                            >
                                Cancelar
                            </button>
                            <button
                                className={`${loading ? 'btn-retiros' : 'bg-green-600'} text-white active:bg-green-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 rounded-full`}
                                type="button"
                                disabled={loading}
                                style={{ transition: "all .15s ease" }}
                                onClick={() => checkUserPassword(password)}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className=" fixed inset-0 z-40 " style={{
                background: 'rgba(47, 46, 44, 0.5)',
                backdropFilter: 'blur(10px)',
            }}>
            </div>
        </>
    )
}
